/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/state-in-constructor */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
import React, { useEffect, useState } from 'react';
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  Input,
  Checkbox,
  ListItemText,
} from '@material-ui/core';
import { Toast } from 'components/Toast';
import useStyles from './styles';
import { getFriendlyErrorMessage } from '../../../utils/errorHelper';

import {
  contentLanguages,
  IContentLanguages,
} from '../../../components/CreateContentTranslation/contentLanguages';

interface ISiteFormProps {
  data: {
    id: string;
    languages: string[];
  };
  mutateData: any;
}

const PageForm: React.FC<ISiteFormProps> = ({ data, mutateData }) => {
  const classes = useStyles();

  const languages = contentLanguages
    .filter((lang) => lang.code !== 'EN')
    .map((language: IContentLanguages) => language.code);

  const [selectedLanguages, setSelectedLanguages] = useState<Array<string>>(
    data.languages,
  );

  const handleSelectChange = (event: React.ChangeEvent<any>) => {
    if (event.target.value) {
      setSelectedLanguages(event.target.value);
    }
  };

  const renderContentTitlesNamesInSelectLabel = (selectedValues: any) => {
    const mappedSelectedLanguages = selectedValues.map(
      (languageCode: string) => {
        return (
          contentLanguages.find(
            (language: any) => language.code === languageCode,
          )?.language || ''
        );
      },
    );
    return mappedSelectedLanguages.join(', ');
  };

  const handleSelectAll = () => {
    setSelectedLanguages(languages);
  };

  const handleUselectAll = () => {
    setSelectedLanguages([]);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const values = {
      id: data?.id,
      languages: selectedLanguages,
    };

    mutateData({
      variables: values,
    }).then(
      () => {
        Toast('Action executed with success!');
      },
      (error: any) => {
        Toast(getFriendlyErrorMessage(error), 'error');
      },
    );
  };

  useEffect(() => {
    setSelectedLanguages(data.languages);
  }, [data]);

  return (
    <form id="myForm" onSubmit={handleSubmit}>
      <Grid
        container
        spacing={1}
        style={{
          flexDirection: 'row',
          justifyContent: 'flex-end',
        }}
      >
        <Grid item lg={12}>
          <Box
            component="div"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <InputLabel className={classes.inputLabel} style={{ marginTop: 0 }}>
              Select Languages
            </InputLabel>

            <Box
              component="div"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Button variant="text" onClick={handleSelectAll}>
                Select All
              </Button>
              &nbsp;&nbsp;/&nbsp;&nbsp;
              <Button variant="text" onClick={handleUselectAll}>
                Unselect All
              </Button>
            </Box>
          </Box>
          <Select
            fullWidth
            labelId="languages"
            id="languages-select"
            multiple
            value={selectedLanguages}
            onChange={(ev) => handleSelectChange(ev)}
            input={<Input />}
            renderValue={(selected) => {
              return renderContentTitlesNamesInSelectLabel(selected);
            }}
            MenuProps={classes.menuProps as any}
            className={classes.menuProps}
          >
            {contentLanguages.map((language: any) => (
              <MenuItem key={language.code} value={language.code}>
                <Checkbox
                  checked={selectedLanguages.indexOf(language.code) > -1}
                />
                <ListItemText primary={language.language} />
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item className={classes.actionButtons}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.btnSave}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default PageForm;
